import { Close } from '@mui/icons-material';
import { Alert, AlertTitle, IconButton } from '@mui/material';
import { toTitleCase } from 'helpers/strings';
import PropTypes from 'prop-types';
import React from 'react';
import toast from 'react-hot-toast';

const RayoToast = ({
  err,
  id,
  message,
  severity = 'error',
  handleErrorDismiss
}) => {
  const onErrorDismiss = () => {
    if (typeof handleErrorDismiss === 'function') {
      handleErrorDismiss(err);
    }
    toast.dismiss(id);
  };
  return (
    <span>
      <Alert
        style={{ margin: 0 }}
        severity={severity}
        variant="filled"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onErrorDismiss}
          >
            <Close fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle>{toTitleCase(severity)}</AlertTitle>
        {message && `${message}`}
        {err && `: ${err.message}`}
      </Alert>
    </span>
  );
};
RayoToast.propTypes = {
  err: PropTypes.instanceOf(Error),
  id: PropTypes.string.isRequired,
  message: PropTypes.string,
  handleErrorDismiss: PropTypes.func,
  severity: PropTypes.oneOf(['success', 'error', 'info', 'warning'])
};

export default RayoToast;
